const bronnen = [
  {
    a: "Arena, A. F., Mobbs, S., Sanatkar, S., Williams, D., Collins, D., Harris, M., Harvey, S. B., & Deady, M.",
    y: "2023",
    t: "Mental health and unemployment: A systematic review and meta-analysis of interventions to improve depression and anxiety outcomes.",
    s: "Journal of Affective Disorders, 335, 450–472.",
  },
  {
    a: "De Haan, E., & Nilsson, V. O.",
    y: "2023",
    t: "What can we know about the effectiveness of coaching? A meta-analysis based only on randomized controlled trials.",
    s: "Academy of Management Learning & Education.",
  },
  {
    a: "Kersten, A., et al.",
    y: "2023",
    t: "Organisational policies and practices for the inclusion of vulnerable workers: A systematic review.",
    s: "Journal of Occupational Rehabilitation.",
  },
  {
    a: "Liu, S., Huang, J. L., & Wang, M.",
    y: "2014",
    t: "Effectiveness of job search interventions: A meta-analytic review.",
    s: "Psychological Bulletin, 140(4), 1009–1041.",
  },
  {
    a: "McKee-Ryan, F. M., Song, Z., Wanberg, C. R., & Kinicki, A. J.",
    y: "2005",
    t: "Psychological and physical well-being during unemployment: A meta-analytic study.",
    s: "Journal of Applied Psychology, 90(1), 53–76.",
  },
  {
    a: "Morris, T. H.",
    y: "2020",
    t: "Experiential learning – A systematic review and revision of Kolb's model.",
    s: "Interactive Learning Environments, 28(8), 1064–1077.",
  },
  {
    a: "Paul, K. I., & Moser, K.",
    y: "2009",
    t: "Unemployment impairs mental health: Meta-analyses.",
    s: "Journal of Vocational Behavior, 74(3), 264–282.",
  },
  {
    a: "Pohlan, L.",
    y: "2019",
    t: "Unemployment and social exclusion.",
    s: "Journal of Economic Behavior & Organization.",
  },
  {
    a: "Ryan, R. M., & Deci, E. L.",
    y: "2000",
    t: "Self-determination theory and the facilitation of intrinsic motivation, social development, and well-being.",
    s: "American Psychologist, 55(1), 68–78.",
  },
  {
    a: "Sturt, J., Ali, S., Robertson, W., Metcalfe, D., Grove, A., Bourne, C., & Bridle, C.",
    y: "2012",
    t: "Neurolinguistic programming: A systematic review of the effects on health outcomes.",
    s: "British Journal of General Practice, 62(604), e757–e764.",
  },
  {
    a: "Vos, J., & Van Rijn, B.",
    y: "2022",
    t: "The effectiveness of Transactional Analysis treatments and their predictors: A systematic literature review and explorative meta-analysis.",
    s: "Journal of Humanistic Psychology.",
  },
];

export default function EvidenceBronnen() {
  return (
    <div>
      <div className="grid grid-cols-1 md:grid-cols-12 gap-10 mb-12">
        <div className="md:col-span-5">
          <p className="text-xs uppercase tracking-[0.25em] text-[#E06B3F] mb-3">Wetenschappelijk fundament</p>
          <h3 className="font-heading text-3xl sm:text-4xl text-[#1D2A22] leading-tight font-light">
            De <span className="italic text-[#E06B3F]">LevelLeven-methodiek</span>{" "}
            bouwt op onderbouwde inzichten.
          </h3>
        </div>
        <div className="md:col-span-7 text-[#4A5D4E] leading-relaxed font-light space-y-4">
          <p>
            De methodiek is opgebouwd uit combinaties van interventies waarvan
            de effectiviteit, of tenminste theoretische onderbouwing, in
            wetenschappelijk onderzoek is beschreven. Sterkte van bewijs
            varieert per bouwsteen. Dit zegt nog niets over de effectiviteit van LevelLeven zelf; die wordt nog onderzocht.
          </p>
          <ul className="text-sm space-y-2 mt-4">
            <li>· <strong className="text-[#1D2A22] font-normal">Sterk bewijs</strong>: relatie werkloosheid & welzijn, SDT, self-efficacy, sociale steun, experiential learning.</li>
            <li>· <strong className="text-[#1D2A22] font-normal">Redelijk bewijs</strong>: coaching (RCT-meta), Transactionele Analyse.</li>
            <li>· <strong className="text-[#1D2A22] font-normal">Beperkter bewijs</strong>: NLP (methodologische beperkingen, Sturt et al., 2012).</li>
          </ul>
        </div>
      </div>

      <div className="rounded-3xl border border-[#E5E1D8] bg-[#FAF7F1] p-6 sm:p-10">
        <p className="text-xs uppercase tracking-[0.25em] text-[#E06B3F] mb-6">
          Bronvermelding, APA 7
        </p>
        <ol className="space-y-5">
          {bronnen.map((b, i) => (
            <li key={i} className="text-sm text-[#1D2A22] leading-relaxed">
              <span className="text-[#7A8276] mr-2">{String(i + 1).padStart(2, "0")}</span>
              {b.a} ({b.y}). <em className="italic">{b.t}</em> {b.s}
            </li>
          ))}
        </ol>
        <p className="mt-8 text-xs text-[#7A8276] italic">
          Volledig Core Profile en Productprofiel, incluis evidence, zijn op
          aanvraag beschikbaar via info@levelleven.nl.
        </p>
      </div>
    </div>
  );
}
